import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  constructor(private http: HttpClient) { }

  getTasks() {
    return this.http.get(environment.v3BaseUrl + '/api/v3/admin-desktop/all-tasks').toPromise();
  }
}
